import { createAction } from 'redux-actions';
import { GET_USER_DATA } from 'redux/constants';
import { UserProfile } from 'utils/api/models/users/userProfile';

interface setLoginAction extends types.redux.api.session.setLoginAction {}
interface setLoginErrorAction extends types.redux.api.session.setLoginErrorAction {}

const setLoginSuccessful: any = createAction('SESSION_SET_LOGIN_SUCCESSFUL');
const setIsWeakPassword: any = createAction('SESSION_SET_PASSWORD_WEAK', (isWeakPassword: boolean) => isWeakPassword);

const setOTPModalOpen: any = createAction('SESSION_OTP_MODAL_OPEN', (open: boolean) => open);
const setOTPWrong: any = createAction('SESSION_OTP_WRONG', (open: boolean) => open);
const setIsOTPValidation: any = createAction('SESSION_OTP_VALIDATING', (open: boolean) => open);
const setIsAuthenticating: any = createAction('SESSION_AUTHENTICATING', (state: boolean) => state);
const setErrorMessage: any = createAction('SESSION_OTP_ERROR_MESSAGE', (error: setLoginErrorAction) => error);

const setLoginUnsuccessful: any = createAction('SESSION_SET_LOGIN_UNSUCCESSFUL');
const setLoginReset: any = createAction('SESSION_SET_LOGIN_RESET');

const setUserProfileData: any = createAction('SESSION_SET_USER_PROFILE_DATA', (data: UserProfile) => data);

const setLogin: any = createAction('SESSION_SET_LOGIN', (data: setLoginAction) => data);
const setNmfloId: any = createAction('SESSION_SET_NMFLOID', (id: string) => id);

const logOut: any = createAction('SESSION_LOGOUT');

const lockScreen: any = createAction('SESSION_LOCK');

const redirectUnauthorized: any = createAction('SESSION_REDIRECT_UNAUTHORIZED');

const setShowWelcomeModal = createAction('SET_SHOW_WELCOME_MODAL', (showWelcomeModal: boolean) => showWelcomeModal);

const getUserData = createAction(GET_USER_DATA);

export {
	setLoginSuccessful,
	setLoginUnsuccessful,
	logOut,
	setUserProfileData,
	lockScreen,
	setLogin,
	redirectUnauthorized,
	setShowWelcomeModal,
	getUserData,
	setNmfloId,
	setIsWeakPassword,
	setOTPModalOpen,
	setOTPWrong,
	setIsOTPValidation,
	setErrorMessage,
	setLoginReset,
	setIsAuthenticating,
};
